import axios from 'axios';
import { config } from '../config';
import { profileParser } from './profile';
import { contentfulParser, getActiveSite } from './contentful';

/**
 * Call /api/account and return modified response based on user logged in status.
 * @param {object} contentfulData Contentfull parsed response.
 * @param {string} apiHost The host domain for the account request, eg https://spyscape.com.
 */
export const fetchAccount = async (contentfulData, apiHost) => {
  try {
    const account = await axios.get(`${apiHost}/api/account`);
    return profileParser(account.data, contentfulData);
  } catch (e) {
    return profileParser(undefined, contentfulData);
  }
};

/**
 * Call contentful api for specific SITE entry id and return parsed response.
 * Before the parsed response returned, a check perfomed for any subsites on current domain path.
 * If a subsite has a slug value which contains the current pathname then
 * we re-fetch the new site entry.
 * @param {string} Contertful SITE entry id.
 */
export const fetchContentfulData = async (contentId) => {
  try {
    const contentful = await getContentfulData(contentId);
    if (contentful.data) {
      const activeSiteId = getActiveSite(contentful.data);
      if (activeSiteId) {
        return fetchContentfulData(activeSiteId);
      }
    }
    return contentfulParser(contentful.data);
  } catch (e) {
    console.error('Contentful parse error', e);
    return contentfulParser({ items: [] });
  }
};

/**
 * Call contentful api and return all entry fields for the specific SITE entry id.
 * @param {string} Contertful SITE entry id.
 */
const getContentfulData = async contentId => axios.get(
  config.contentful.apiUrl, {
    params: {
      access_token: config.contentful.accessToken,
      select: 'fields',
      'sys.id': contentId,
      include: '3',
    },
  },
);
